// extracted by mini-css-extract-plugin
export default {"table":"purchase-order-list_table__83fXc","iconCustom":"purchase-order-list_iconCustom__OOqoq"};